"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMockFinancialInsights = void 0;
const types_1 = require("@hum/types");
const faker_1 = require("@faker-js/faker");
const createMockFinancialInsights = (overwrites = {}) => {
    const icmId = faker_1.faker.datatype.number({ min: 1 });
    return {
        profile: Object.assign({ companyInformation: {
                createdAtDate: faker_1.faker.date.past().toISOString(),
                icmId,
                companyName: faker_1.faker.datatype.string(),
                website: faker_1.faker.internet.url(),
                industry: faker_1.faker.datatype.string(),
                hasRecurringRevenu: faker_1.faker.datatype.boolean(),
                runwayInQuarters: faker_1.faker.datatype.number({ min: 0 }),
            }, historicalFundingInformation: {
                investors: [],
                historicalRaiseTypes: [],
                totalCapitalRaised: faker_1.faker.datatype.number({ min: 0 }),
                totalEquityRaised: faker_1.faker.datatype.number({ min: 0 }),
                totalDebtRaised: faker_1.faker.datatype.number({ min: 0 }),
                latestRaiseDate: faker_1.faker.date.past().toISOString(),
                latestRaiseType: faker_1.faker.datatype.string(),
                latestRaiseAmount: faker_1.faker.datatype.number({ min: 0 }),
            }, currentDealDetails: {
                dealType: faker_1.faker.datatype.string(),
                useOfProceeds: faker_1.faker.datatype.string(),
                expectedRaiseAmount: faker_1.faker.datatype.number({ min: 1000000 }),
            }, humsProprietaryScoringModels: {
                lastQuarterDate: faker_1.faker.date.past().toISOString(),
                models: {
                    growthScore: {
                        value: faker_1.faker.datatype.number({ min: 0 }),
                        yoyGrowth: faker_1.faker.datatype.number({ min: 0 }),
                    },
                    operatingEfficiencyScore: {
                        value: faker_1.faker.datatype.number({ min: 0 }),
                        yoyGrowth: faker_1.faker.datatype.number({ min: 0 }),
                    },
                    maxDebt: {
                        value: faker_1.faker.datatype.number({ min: 0 }),
                        yoyGrowth: faker_1.faker.datatype.number({ min: 0 }),
                    },
                    maxNewDebt: {
                        value: faker_1.faker.datatype.number({ min: 0 }),
                        yoyGrowth: faker_1.faker.datatype.number({ min: 0 }),
                    },
                },
            } }, (overwrites.profile || {})),
        benchmarking: Object.assign({ header: {
                lastQuarterDate: faker_1.faker.date.past().toISOString(),
                numberOfSimilarCompanies: faker_1.faker.datatype.number({ min: 10 }),
                period: types_1.PeriodType.TTM,
            }, company: {
                scaleOfBusiness: {
                    revenueOperatingSms4: faker_1.faker.datatype.number({ min: 0 }),
                    ebitdaAdjPreMarketingSms4: faker_1.faker.datatype.number({ min: 0 }),
                    ebitdaAdjSms4: faker_1.faker.datatype.number({ min: 0 }),
                    assetsCurrentCashAndInvestments: faker_1.faker.datatype.number({ min: 0 }),
                    assetsCurrentInvty: faker_1.faker.datatype.number({ min: 0 }),
                    assetsCurrentRcv: faker_1.faker.datatype.number({ min: 0 }),
                    assetsNonCurrentNetPropPlantEquipment: faker_1.faker.datatype.number({
                        min: 0,
                    }),
                },
                growth: {
                    revenueOperatingSms4Ret4: faker_1.faker.datatype.number({ min: 0 }),
                    ebitdaAdjPreMarketingSms4Ret4: faker_1.faker.datatype.number({ min: 0 }),
                    ebitdaAdjSms4Ret4: faker_1.faker.datatype.number({ min: 0 }),
                    assetsCurrentCashAndInvestmentsRet4: faker_1.faker.datatype.number({
                        min: 0,
                    }),
                    assetsCurrentInvtyRet4: faker_1.faker.datatype.number({ min: 0 }),
                    assetsCurrentRcvRet4: faker_1.faker.datatype.number({ min: 0 }),
                    assetsNonCurrentNetPropPlantEquipmentRet4: faker_1.faker.datatype.number({
                        min: 0,
                    }),
                },
                marginProfile: {
                    grossProfitAdjSms4DivRevenueOperatingSms4: faker_1.faker.datatype.number({
                        min: 0,
                    }),
                    ebitdaAdjPreMarketingSms4DivRevenueOperatingSms4: faker_1.faker.datatype.number({ min: 0 }),
                    salesMarketingSms4DivRevenueOperatingSms4: faker_1.faker.datatype.number({
                        min: 0,
                    }),
                },
                marginImprovement: {
                    grossProfitAdjSms4DivRevenueOperatingSms4Ret4: faker_1.faker.datatype.number({
                        min: 0,
                    }),
                    ebitdaAdjPreMarketingSms4DivRevenueOperatingSms4Ret4: faker_1.faker.datatype.number({ min: 0 }),
                    salesMarketingSms4DivRevenueOperatingSms4Ret4: faker_1.faker.datatype.number({
                        min: 0,
                    }),
                },
                capitalStructure: {
                    equityPaidInCapital: faker_1.faker.datatype.number({ min: 0 }),
                    debtTotal: faker_1.faker.datatype.number({ min: 0 }),
                },
            }, data: {
                distribution: {},
                topQuartile: faker_1.faker.datatype.number({ min: 0 }),
            } }, (overwrites.benchmarking || {})),
        investorPreferences: Object.assign({ header: {
                source: 'Company Data',
                companyMetrics: {
                    arr: faker_1.faker.datatype.number({ min: 0 }),
                    revenueGrowth: faker_1.faker.datatype.number({ min: 0 }),
                    ebitda: faker_1.faker.datatype.number({ min: 0 }),
                    ebitdaMargin: faker_1.faker.datatype.number({ min: 0 }),
                    ebitdaMarginGrowth: faker_1.faker.datatype.number({ min: 0 }),
                    runway: faker_1.faker.datatype.number({ min: 0 }),
                    naicsCode: faker_1.faker.datatype.number({ min: 0 }),
                    zoominfoIndustry: faker_1.faker.datatype.string(),
                    useOfProceeds: faker_1.faker.datatype.string(),
                    adjEbitda: faker_1.faker.datatype.number({ min: 0 }),
                    adjEbitdMargin: faker_1.faker.datatype.number({ min: 0 }),
                },
            }, creditBox: {} }, (overwrites.investorPreferences || {})),
    };
};
exports.createMockFinancialInsights = createMockFinancialInsights;
//# sourceMappingURL=FinancialInsights.factory.js.map